import { render, staticRenderFns } from "./addBanner.vue?vue&type=template&id=476d1b34&scoped=true"
import script from "./addBanner.vue?vue&type=script&lang=js"
export * from "./addBanner.vue?vue&type=script&lang=js"
import style0 from "./addBanner.vue?vue&type=style&index=0&id=476d1b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d1b34",
  null
  
)

export default component.exports